<template>
    <div class="auth-container">
        <form @submit.prevent="signUp">
            <h1>Create Account</h1>
            <h4>Please fill the input below here</h4>
            <div v-if="email_exists" style="color:red; text-transform: uppercase"> Email already exists </div>
            <div class="form-group">
                <label>YOUR USERNAME</label>
                <input type="text" class="form-control auth-form-control" v-model="username" placeholder="username" required/>
            </div>

            <div class="form-group">
                <label>YOUR EMAIL</label>
                <input type="email" class="form-control auth-form-control" v-model="email" placeholder="user@example.com" required/>
            </div>

            <div class="form-group">
                <label>YOUR PASSWORD</label>
                <input type="password" class="form-control auth-form-control" v-model="password" placeholder="password" required/>
            </div>

            <div class="form-group">
                <label>REPEAT YOUR PASSWORD</label>
                <input type="password" class="form-control auth-form-control" v-model="password_confirm" placeholder="password" required/>
            </div>
            <div v-if="same_passwords" style="color:red"> SAME PASSWORDS </div>
            <button class="btn-auth">Sign Up</button>
        </form>
    </div>
    <div class="auth-footer">
        <span>Already have an account? </span>
        <a href="/login">Login</a>
    </div>
</template>

<script>

import axios from 'axios'
export default {
    name: 'Signup',
    data() {
        return {
            username: '',
            email: '' ,
            password: '',
            password_confirm: '',
            same_passwords: false,
            email_exists: false
        }
    },
    methods: {
        signUp() {

            if (this.password_confirm == this.password){
                this.same_passwords = false
                var formData = new FormData()

                formData.append('username', this.username)
                formData.append('email', this.email)
                formData.append('password', this.password)
                
                axios.post(process.env.VUE_APP_BACK_URL + "/signup", formData, {
                    headers: { "Content-Type": "multipart/form-data" }
                }).then((response) => {
                    if (response.data.code == 0){
                        this.$store.commit('changeId', response.data.user_id)
                        this.$store.commit('changeEmail', this.email)
                        this.$router.push('profile')
                    } else if (response.data.code == -1){
                        this.email_exists = true
                    }
                }).catch(() => {
                })
            } else {
                this.same_passwords = true
            }
        },
        updateLoc() {
            this.$store.commit('changeLoc', false)
        }
    },
    mounted() {
        this.updateLoc()
    },
}
</script>